import React, { FC } from 'react';
import { Modal } from 'react-bootstrap';

interface IClSitePreview {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  siteName: string;
  siteUrl: string;
}

export const ClSitePreview: FC<IClSitePreview> = ({
  show,
  setShow,
  siteName,
  siteUrl,
}) => {
  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
      centered
      fullscreen={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{siteName} Site Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <iframe
          title={siteName}
          src={siteUrl}
          frameBorder="0"
          width="100%"
          height="100%"
        />
      </Modal.Body>
    </Modal>
  );
};
